import React from "react";
import merge from "lodash/merge";
import { createContext, useState } from "react";
// CUSTOM COMPONENT
import { TheHousingHubLayoutSettings } from "app/components/TheHousingHubLayout/settings";

export const SettingsContext = createContext({
  settings: TheHousingHubLayoutSettings,
  updateSettings: () => {}
});

export default function SettingsProvider({ settings, children }) {
  const [currentSettings, setCurrentSettings] = useState(settings || TheHousingHubLayoutSettings);

  const handleUpdateSettings = (update = {}) => {
    const marged = merge({}, currentSettings, update);
    setCurrentSettings(marged);
  };

  return (
    <SettingsContext.Provider
      value={{ settings: currentSettings, updateSettings: handleUpdateSettings }}
    >
      {children}
    </SettingsContext.Provider>
  );
}
